import CheckDatabase from './CheckDatabase';

export default CheckDatabase;
